import i18next from '@packages/core/i18n';

import enLocales from './en';
import { NAMESPACE } from './namespace';

i18next.addResourceBundle('en', NAMESPACE, enLocales);

export default i18next;
